import { useVersionCheck } from "./composables/use-version-check";
import { defineNuxtPlugin, useRuntimeConfig } from "#imports";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (typeof window !== "undefined") {
    Object.defineProperty(window, "__VERSION__", {
      value: config.public.versionCheck.buildName,
      writable: false,
      configurable: true,
    });
  }

  const { startVersionCheck } = useVersionCheck();

  if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
      startVersionCheck();
    });
  } else {
    setTimeout(() => {
      startVersionCheck();
    }, 1000);
  }
});
